














import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "UnlockForButton",
  components: { BaseButton, FormatMoney },
  props: {
    secondary: { type: Boolean, default: false },
    gradient: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    cost: { type: Number, default: 0 },
  },
});
